import * as React from "react";
export const BeTestedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={50} height={50} viewBox="0 0 435 642" {...props}>
      <path
        fill="#fe5000"
        d="M217.31 206.94L191.23 206.94C138.42 206.94 95.61 249.75 95.61 302.55L217.31 302.55C284.51 302.55 339 357.04 339 424.25C339 491.45 284.51 545.94 217.31 545.94C150.1 545.94 95.61 491.45 95.61 424.25L95.61 80.08C95.61 35.91 59.8 0.1 15.63 0.1L0 0.1L0 424.25C0 544.26 97.29 641.55 217.31 641.55C337.32 641.55 434.61 544.26 434.61 424.25C434.61 304.23 337.32 206.94 217.31 206.94Z"
      />
    </svg>
  );
};
